import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const NewsPage = () => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    axios
      .get('http://127.0.0.1:8000/api/news/')
      .then((response) => {
        setNews(response.data); // JSON ma'lumotni state'ga saqlash
      })
      .catch((error) => {
        console.error("Xatolik:", error);
      });
  }, []);

  return (
    <>
      <div className="max-w-5xl mx-auto p-6 mt-32">
        <h1 className="text-3xl font-bold mb-6">Yangiliklar</h1>

        <div className="grid md:grid-cols-2 gap-6">
          {news.length > 0 ? (
            news.map((newsItem) => (
              <div key={newsItem.id} className="bg-white shadow-md rounded-lg overflow-hidden">
                <img
                  src={`http://127.0.0.1:8000${newsItem.photo}`} // 🖼️ Backenddan kelgan rasmga to‘liq URL
                  alt={newsItem.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-4">
                  <h2 className="text-xl font-semibold">{newsItem.title}</h2>
                  <p className="text-gray-600 text-sm">{newsItem.date}</p>
                  <p className="text-gray-700 mt-2">{newsItem.description}</p>
                  <Link
                    to={`/news/${newsItem.slug}`}
                    className="text-blue-500 mt-3 inline-block"
                  >
                    Batafsil →
                  </Link>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500">Yangiliklar topilmadi.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default NewsPage;

